import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { ConvertMainteInfo, Maintenance } from 'src/lib/entity/live';
import { CommonService } from 'src/lib/services/common-service'

export type Menu = 'maintenance' | 'maintenance_setting'

@Component({
  selector: 'maintenance-show',
  templateUrl: './maintenance-show.component.html',
  styleUrls: [ '../../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss', './maintenance-show.component.scss']
})

export class MaintenanceShowComponent implements OnInit {

  maintenanceInfo: ConvertMainteInfo;

  constructor(
    private afs: AngularFirestore,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.reloadMaintenanceInfo();
  }

  private reloadMaintenanceInfo() {
    this.afs.collection<Maintenance>("maintenance")
      .valueChanges()
      .subscribe((value: any) => {
        let x = value[0];

        this.maintenanceInfo = {
          startedAt: x.startedAt.toDate().toISOString(),
          endedAt:   x.endedAt.toDate().toISOString(),
          isMaintenance: false,
          isMainteFeature: false,
          maintenanceText: '',
          platform: ''
        }

        let today = new Date(Date.now());
        let startedAt = new Date(this.maintenanceInfo.startedAt)
        let endedAt = new Date(this.maintenanceInfo.endedAt)

        // メンテナンス中か判定
        if (today >= startedAt && today <= endedAt) {
          // メンテナンス中
          this.maintenanceInfo.isMaintenance = true
          this.maintenanceInfo.maintenanceText = "メンテナンス中"
        } else if (today <= startedAt && today <= endedAt) {
          // 稼働中 (メンテナンス予定有り)
          this.maintenanceInfo.isMainteFeature = true
          this.maintenanceInfo.isMaintenance = true
          this.maintenanceInfo.maintenanceText = "稼働中 (メンテナンス予定有り)"
        } else {
          // 非稼働
          this.maintenanceInfo.maintenanceText = "稼働中 (メンテナンス予定無し)"
        }
        this.maintenanceInfo.platform = this.showPlatformResult(x.platform)
        this.commonService.setMaintenanceData(this.maintenanceInfo)  // データをsharedサービスに渡す
      });
  }

  public showPlatformResult(platformInfo: Array<any>): string {
    let result = '';
    let web = platformInfo.find(value => value === 'maglive-web-front')
    let ios = platformInfo.find(value => value === 'maglive-iOS')
    let android = platformInfo.find(value => value === 'maglive-android')

    if (ios && android && web) {
      return '全プラットフォーム'
    }

    if (web) { result += '【PC/その他】 ';}
    if (ios) { result += '【iOS】';}
    if (android) { result += '【Android】';}

    return result;
  }
}
